<template>
  <div>
    <el-button
      v-if="power(userInfo.menuInfoList, 'link-export')"
      type="primary"
      class="el-icon-upload2"
      size="small"
      @click="toExport"
      >导出</el-button
    >
    <el-button type="primary" size="small" @click="download"
      >下载所有环节资源</el-button
    >
  </div>
</template>

<script>
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState } from "vuex";
import { downloadUrlFile, saveAs, power, fileSaveZip } from "@/utils/index.js";
export default {
  props: {
    url: {
      type: String,
    },
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    toExport() {
      postData(this.url, {
        actCode: sessionStorage.getItem("actCode"),
      }).then((data) => {
        fileSaveZip(data.url, data.name);
      });
    },
    power,
    saveAs(url, name) {
      const save_link = document.createElement("a");
      document.body.appendChild(save_link);
      save_link.style.display = "none";
      save_link.href = url;
      save_link.download = name;
      save_link.click();
      document.body.removeChild(save_link);
      return true; // 确认下载完成 后面进行下载记录保存
    },
    download() {
      postData("/node/downloadActAttachesZip", {
        actCode: sessionStorage.getItem("actCode"),
        operatorId: this.userInfo.userId,
      }).then((res) => {
        // 保存到本地并自动点击
        fileSaveZip(res.url, res.name);
        // this.saveAs(res.url, res.name);
        // downloadUrlFile(res.url, res.name);
      });
    },
  },
};
</script>

<style>
</style>
